const colors = {
  black: '#333',
  grey200: '#444',
  grey300: '#e5e5ea',
  grey400: '#c7c7cc',
  grey500: '#8e8e93',
  grey600: '#f7f7f9',
  hudsonRed: '#C50E29',
  orange100: '#ff867f',
  orange200: '#ff5252',
  white: '#FFFFFF',
  blue: '#85B7D9',
};

export default colors;
